import { reducer } from './reducer';
import { sagas } from './sagas';
import { REDUCER_NAME } from './constants';


export * from './actions';
export * as UploadsTypes from './types';
export { uploadFileWithProgress } from './sagas';
export * from './hooks';

export const state = {
    reducer: {
        [REDUCER_NAME]: reducer,
    },
    sagas,
};
